export enum DocumentLinkTypeEnum {
    Document = 1,
    Link = 2
}